.nav {
    position: absolute;
    top: 0px;
    left: -320px;
    width: 20rem;
    height: 100%;
    z-index: 10000;
    filter: drop-shadow(0px 0px 0px #231d2ee3);
    backdrop-filter: blur(0.1rem);
  }
  
  .primaryNavigation {
    height: 100%;
    margin: 0;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    background-color: white;
    padding-top: 2rem !important;
  }
  
  .primaryNavigation li {
    list-style: none;
    margin-bottom: 0.5rem;
    box-sizing: initial;
    border: 1px solid white;
  }

  .primaryNavigation .navIcon {
    margin:0;
    padding:0;
    min-width: 40px;
  }

  .primaryNavigation .navText span {
    color: rgb(72, 72, 72) !important;
    font-size: 0.9rem;
    font-weight: 300;
    font-family: "Roboto-Medium", Helvetica, Arial, sans-serif;
  }
  .primaryNavigation .navItem {
    cursor: pointer;
  }

  .primaryNavigation .navIcon svg{
    max-width: 25px;
  }
  
  .primaryNavigation .MuiListItemIcon-root {
    min-width: 3.5rem;
  }
  
  .primaryNavigation li svg{
    width: 24px;
  }
  
  .primaryNavigation > li:hover {
    background-color: #ae535310;
    border-radius: 0.5rem 0 0 0.5rem;
    border: 1px solid #ed515130;
  } 